import karmaEarnGameSlice from './slice';

export default karmaEarnGameSlice.reducer;
